import React from 'react';

export default function Overlay_Prototype() {
    
    return (
        <div className="Overlay_Prototype">
            <p className='Overlay_Prototype_Text'>
                {/* <a target="_blank" href='https://elmerf5445.github.io/Digi-Rooms-Status/Pages/DRS_Main.html' rel="noreferrer">Resources</a> */}
                 {/* | <a target="_blank" href='https://forms.gle/izjYqZDc2kaofSbu9' rel="noreferrer">Teachers' Form</a> | <a target="_blank" href='https://forms.gle/NDnwPnWxbsQ2P1zo6' rel="noreferrer">Staff's Form</a> */}
            </p>
        </div>
    );
}
